module.exports = __webpack_public_path__ + "img/Account-Credit-Grey.da348c0e.svg";